import script from "./base-disabler.vue?vue&type=script&lang=ts"
export * from "./base-disabler.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__